import React from 'react';
import { ModalBody, Modal } from 'reactstrap';
import { Loader } from './Loader';

export const ModalLoader = () => {
  return (
    <Modal isOpen centered>
      <ModalBody>
        <Loader />
      </ModalBody>
    </Modal>
  );
};
